import { useEffect, useState, useRef } from 'react'

import { Tabs, TabsRef } from 'flowbite-react'
import { useLocation, useNavigate } from 'react-router-dom'

import DevolucoesContainer from '@/containers/devolucoes/devolucoes.container'
import { DevolucoesContext } from '@/contexts/devolucoes.context'
import RegistrosContainer from '@/containers/devolucoes/registros.container'
import { RegistrosContext } from '@/contexts/registros.context'

import { TAB_THEME } from '../detalhe/tab-theme'
import { useGetUserData } from '@/hooks/queries/use-get-user-data'
import { useGetFeatureFlagData } from '@/hooks/queries/use-get-feature-flag-data'

const DevolucoesView = () => {
  const tabsRef = useRef<TabsRef>(null)
  const location = useLocation()
  const navigate = useNavigate()
  const { data: userData } = useGetUserData()
  const [isFeatureFlagEnabled, setIsFeatureFlagEnabled] = useState<boolean>(false)

  const { data: featureFlagData } = useGetFeatureFlagData({
    employerId: userData?.authenticatedAccountId,
    featureFlag: 'devolucao-em-lote'
  });

  useEffect(() => {
    setIsFeatureFlagEnabled(featureFlagData?.sucesso)
  }, [featureFlagData]);

  useEffect(() => {
    const activeTabLabel = document.querySelectorAll('[type="button"]')
    activeTabLabel.forEach(tab => {
      tab.addEventListener('click', () => {
        tab.textContent === 'Devoluções' &&
          navigate('/pedidos/devolucoes')
        tab.textContent === 'Registro de Devoluções' &&
          navigate('/pedidos/registro')
      })
    })
    const currentTab = tabsRef.current
    location.pathname === '/pedidos/registro' && currentTab.setActiveTab(1)
    location.pathname === '/pedidos/devolucoes' && currentTab.setActiveTab(0)
  }, [location, tabsRef])

  return (
    <div className='w-full bg-white rounded-md p-5 md:-mt-8'>
      <Tabs
        aria-label='Tabs with underline'
        variant='default'
        theme={TAB_THEME}
        ref={tabsRef}
      >
        <Tabs.Item
          title="Devoluções"
          id='devolucoes'
          className='step-tab-devolucoes'
        >
          <DevolucoesContext>
            <DevolucoesContainer />
          </DevolucoesContext>
        </Tabs.Item>
        {isFeatureFlagEnabled && (
          <Tabs.Item
            title="Registro de Devoluções"
            id='registro'
            className='step-tab-registro'
          >
            <RegistrosContext>
              <RegistrosContainer />
            </RegistrosContext>
          </Tabs.Item>
        )}
      </Tabs>
    </div>
  )
}

export default DevolucoesView
